import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import Loading from '@/components/Loading.vue';
import store from '@/store';
import { ref } from 'vue';
import { getUserBasicInfo } from '@/api/careersheetEndpoint';
import { stringToDate, ymdHyphenFormat } from '@/utils/dateFormat';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    const userBasicInfo = await getUserBasicInfo();
    const firstName = userBasicInfo.firstName || '';
    const lastName = userBasicInfo.lastName || '';
    const firstNameKana = userBasicInfo.firstNameKana || '';
    const lastNameKana = userBasicInfo.lastNameKana || '';
    const sexFlg = userBasicInfo.sexFlg || null;
    const birthDate = String(userBasicInfo.birthDate) !== '' ? ymdHyphenFormat(stringToDate(userBasicInfo.birthDate)) : '';
    const telCellular = userBasicInfo.telCellular || '';
    const zipCode = userBasicInfo.zipCode || '';
    const prefId = userBasicInfo.prefId ? String(userBasicInfo.prefId) : '';
    const addr1 = userBasicInfo.addr1 || '';
    const addr2 = userBasicInfo.addr2 || '';
    const addr3 = userBasicInfo.addr3 || '';

    store.commit('userRegistration/setFirstName', firstName);
    store.commit('userRegistration/setLastName', lastName);
    store.commit('userRegistration/setFirstNameKana', firstNameKana);
    store.commit('userRegistration/setLastNameKana', lastNameKana);
    store.commit('userRegistration/setSexFlg', sexFlg);
    store.commit('userRegistration/setBirthDate', birthDate);
    store.commit('userRegistration/setTelCellular', telCellular);
    store.commit('userRegistration/setZipCode', zipCode);
    store.commit('userRegistration/setPrefId', prefId);
    store.commit('userRegistration/setAddr1', addr1);
    store.commit('userRegistration/setAddr2', addr2);
    store.commit('userRegistration/setAddr3', addr3);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})